import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import MuiCard from "@mui/material/Card";
import CssBaseline from "@mui/material/CssBaseline";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import { styled } from "@mui/material/styles";
import * as React from "react";
import { useNavigate } from "react-router-dom";
import { AuthState, SignInData, fetchAuth, useAppDispatch } from "../../redux";
// import ForgotPassword from './ForgotPassword';
// import { GoogleIcon, FacebookIcon, SitemarkIcon } from './CustomIcons';
// import AppTheme from '../shared-theme/AppTheme';
// import ColorModeSelect from '../shared-theme/ColorModeSelect';
// import { AppProvider } from "@toolpad/core/AppProvider";
// import { SignInPage, type AuthProvider } from "@toolpad/core/SignInPage";
// import { useTheme } from "@mui/material/styles";
// import { AuthState, SignInData, fetchAuth, useAppDispatch } from "../redux";

// // preview-start
// const providers = [{ id: "credentials", name: "Email and Password" }];
// // preview-end

// export default function CredentialsSignInPage() {
//   const dispatch = useAppDispatch();
//   const siginBackend = async (userName: string, password: string) => {
//     const data: SignInData = {
//       userName: userName,
//       password: password,
//     };
//     const resultAction = await dispatch(fetchAuth(data));

//     const payload: AuthState = resultAction.payload as AuthState;
//   };
//   const signIn: (provider: AuthProvider, formData: FormData) => void = async (
//     provider,
//     formData
//   ) => {
//     const promise = new Promise<void>((resolve) => {
//       setTimeout(() => {
//         const userName = formData.get("email")?.toString();
//         const password = formData.get("password")?.toString();
//         if (userName && password) siginBackend(userName, password);
//         alert(
//           `Signing in with "${provider.name}" and credentials: ${formData.get("email")}, ${formData.get("password")}`
//         );
//         resolve();
//       }, 300);
//     });
//     return promise;
//   };

//   const theme = useTheme();
//   return (
//     // preview-start
//     // <AppProvider theme={theme}>
//     <SignInPage
//       signIn={signIn}
//       providers={[{ id: "credentials", name: "User Name and Password" }]}
//     />
//     // </AppProvider>
//     // preview-end
//   );
// }

const Card = styled(MuiCard)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignSelf: "center",
  width: "100%",
  padding: theme.spacing(4),
  gap: theme.spacing(2),
  margin: "auto",
  [theme.breakpoints.up("sm")]: {
    maxWidth: "450px",
  },
  boxShadow:
    "hsla(220, 30%, 5%, 0.05) 0px 5px 15px 0px, hsla(220, 25%, 10%, 0.05) 0px 15px 35px -5px",
  ...theme.applyStyles("dark", {
    boxShadow:
      "hsla(220, 30%, 5%, 0.5) 0px 5px 15px 0px, hsla(220, 25%, 10%, 0.08) 0px 15px 35px -5px",
  }),
}));

const SignInContainer = styled(Stack)(({ theme }) => ({
  height: "calc((1 - var(--template-frame-height, 0)) * 100dvh)",
  minHeight: "100%",
  padding: theme.spacing(2),
  [theme.breakpoints.up("sm")]: {
    padding: theme.spacing(4),
  },
  "&::before": {
    content: '""',
    display: "block",
    position: "absolute",
    zIndex: -1,
    inset: 0,
    backgroundImage:
      "radial-gradient(ellipse at 50% 50%, hsl(210, 100%, 97%), hsl(0, 0%, 100%))",
    backgroundRepeat: "no-repeat",
    ...theme.applyStyles("dark", {
      backgroundImage:
        "radial-gradient(at 50% 50%, hsla(210, 100%, 16%, 0.5), hsl(220, 30%, 5%))",
    }),
  },
}));

export default function CredentialsSignInPage(props: {
  disableCustomTheme?: boolean;
}) {
  const [userNameError, setUserNameError] = React.useState(false);
  const [userNameErrorMessage, setUserNameErrorMessage] = React.useState("");
  const [passwordError, setPasswordError] = React.useState(false);
  const [passwordErrorMessage, setPasswordErrorMessage] = React.useState("");
  const [open, setOpen] = React.useState(false);
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const siginBackend = async (userName: string, password: string) => {
    const data: SignInData = {
      userName: userName,
      password: password,
    };
    const resultAction = await dispatch(fetchAuth(data));
    const payload: AuthState = resultAction.payload as AuthState;
    return payload;
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleSubmit = () => {
    //React.FormEvent<HTMLFormElement>) => {
    // const data = new FormData(event.currentTarget);
    const userName = document.getElementById("userName") as HTMLInputElement;
    const password = document.getElementById("password") as HTMLInputElement;
    if (validateInputs()) {
      siginBackend(userName.value, password.value)
        .then((response: AuthState) => {
          if (response.loadingStatus === "error") {
            setUserNameError(true);
            setUserNameErrorMessage(response.error ? response.error : "");
          } else navigate("/");
        })
        .catch((error: any) => console.log("error", error));
    }
    // if (userNameError || passwordError) {
    //   event.preventDefault();
    //   return;
    // }
    // const data = new FormData(event.currentTarget);
    // console.log({
    //   userName: data.get("userName"),
    //   password: data.get("password"),
    // });
  };

  const validateInputs = () => {
    const userName = document.getElementById("userName") as HTMLInputElement;
    const password = document.getElementById("password") as HTMLInputElement;

    let isValid = true;

    if (
      !userName.value ||
      /^(?=\w*\d)(?=\w*[A-Z])(?=\w*[a-z])\S{8,16}$/.test(userName.value)
    ) {
      setUserNameError(true);
      setUserNameErrorMessage("Por favor ingrese un nombre de usuario válido.");
      isValid = false;
    } else {
      setUserNameError(false);
      setUserNameErrorMessage("");
    }

    if (!password.value || password.value.length < 6) {
      setPasswordError(true);
      setPasswordErrorMessage("Password must be at least 6 characters long.");
      isValid = false;
    } else {
      setPasswordError(false);
      setPasswordErrorMessage("");
    }

    return isValid;
  };

  return (
    // <AppTheme {...props}>
    <Box>
      <CssBaseline enableColorScheme />
      <SignInContainer direction="column" justifyContent="space-between">
        {/* <ColorModeSelect sx={{ position: 'fixed', top: '1rem', right: '1rem' }} /> */}
        <Card variant="outlined">
          {/* <SitemarkIcon /> */}
          <Typography component="h1" variant="h6" sx={{ width: "100%" }}>
            Ingresar - COFOLP
          </Typography>
          <Box
            component="form"
            // onSubmit={handleSubmit}
            noValidate
            sx={{
              display: "flex",
              flexDirection: "column",
              width: "100%",
              gap: 2,
            }}
          >
            <FormControl>
              <FormLabel htmlFor="userName">Nombre de Usuario</FormLabel>
              <TextField
                error={userNameError}
                helperText={userNameErrorMessage}
                id="userName"
                type="text"
                name="userName"
                placeholder="Nombre de usuario"
                autoComplete="userName"
                autoFocus
                required
                fullWidth
                variant="outlined"
                color={userNameError ? "error" : "primary"}
                sx={{ ariaLabel: "userName" }}
              />
            </FormControl>
            <FormControl>
              <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                <FormLabel htmlFor="password">Contraseña</FormLabel>
                {/* <Link
                  component="button"
                  type="button"
                  onClick={handleClickOpen}
                  variant="body2"
                  sx={{ alignSelf: "baseline" }}
                >
                  Forgot your password?
                </Link> */}
              </Box>
              <TextField
                error={passwordError}
                helperText={passwordErrorMessage}
                name="password"
                placeholder="••••••"
                type="password"
                id="password"
                autoComplete="current-password"
                autoFocus
                required
                fullWidth
                variant="outlined"
                color={passwordError ? "error" : "primary"}
              />
            </FormControl>
            {/* <FormControlLabel
              control={<Checkbox value="remember" color="primary" />}
              label="Remember me"
            /> */}
            {/* <ForgotPassword open={open} handleClose={handleClose} /> */}
            <Button
              type="button"
              fullWidth
              variant="contained"
              onClick={handleSubmit}
            >
              Ingresar
            </Button>
            {/* <Typography sx={{ textAlign: "center" }}>
              Don&apos;t have an account?{" "}
              <span>
                <Link
                  href="/material-ui/getting-started/templates/sign-in/"
                  variant="body2"
                  sx={{ alignSelf: "center" }}
                >
                  Sign up
                </Link>
              </span>
            </Typography> */}
          </Box>
          {/* <Divider>or</Divider> */}
          {/* <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            <Button
              fullWidth
              variant="outlined"
              onClick={() => alert('Sign in with Google')}
              startIcon={<GoogleIcon />}
            >
              Sign in with Google
            </Button>
            <Button
              fullWidth
              variant="outlined"
              onClick={() => alert('Sign in with Facebook')}
              startIcon={<FacebookIcon />}
            >
              Sign in with Facebook
            </Button>
          </Box> */}
        </Card>
      </SignInContainer>
      {/* </AppTheme> */}
    </Box>
  );
}
